import {
  AddressBook,
  ArrowCounterClockwise,
  ArrowFatRight,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  Bank,
  Bell,
  BellRinging,
  CalendarCheck,
  CalendarDots,
  CalendarPlus,
  CalendarX,
  CameraPlus,
  CaretDoubleUp,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  ChatDots,
  Check,
  CheckCircle,
  ClipboardText,
  Clock,
  Copy,
  CreditCard,
  Cube,
  CurrencyCircleDollar,
  Dot,
  DotOutline,
  DotsThreeOutline,
  DownloadSimple,
  Envelope,
  Eye,
  EyeSlash,
  Files,
  FileText,
  FlowerLotus,
  Funnel,
  Gear,
  Gift,
  GoogleLogo,
  House,
  Info,
  Invoice,
  Key,
  Lightning,
  List,
  ListPlus,
  Lock,
  MagnifyingGlass,
  MapPinArea,
  MapPinLine,
  MapPinPlus,
  MapPinSimpleArea,
  Medal,
  MessengerLogo,
  Minus,
  Notepad,
  NotePencil,
  Package,
  PawPrint,
  Phone,
  Plus,
  Question,
  Receipt,
  SealPercent,
  ShareFat,
  ShieldCheck,
  ShoppingCart,
  SidebarSimple,
  SignOut,
  SmileySad,
  Sparkle,
  SquaresFour,
  StackPlus,
  Star,
  StarFour,
  TelegramLogo,
  ThumbsUp,
  Timer,
  Trash,
  TrayArrowUp,
  User,
  UserCircle,
  UserList,
  UsersThree,
  UserSwitch,
  Wallet,
  Warning,
  WarningCircle,
  WhatsappLogo,
  X,
  XCircle,
} from "@phosphor-icons/react";

export const IconList = {
  AddressBook,
  ArrowCounterClockwise,
  ArrowFatRight,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  Bank,
  Bell,
  BellRinging,
  CalendarCheck,
  CalendarDots,
  CalendarPlus,
  CalendarX,
  CameraPlus,
  CaretDoubleUp,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  ChatDots,
  Check,
  CheckCircle,
  ClipboardText,
  Clock,
  Copy,
  CreditCard,
  Cube,
  CurrencyCircleDollar,
  Dot,
  DotOutline,
  DotsThreeOutline,
  DownloadSimple,
  Envelope,
  FileText,
  Files,
  FlowerLotus,
  Funnel,
  Gear,
  Gift,
  GoogleLogo,
  House,
  Info,
  Invoice,
  Key,
  Lightning,
  List,
  ListPlus,
  MagnifyingGlass,
  MapPinArea,
  MapPinLine,
  MapPinPlus,
  MapPinSimpleArea,
  Medal,
  MessengerLogo,
  Minus,
  NotePencil,
  Notepad,
  Package,
  PawPrint,
  Phone,
  Plus,
  Question,
  Receipt,
  SealPercent,
  ShareFat,
  ShieldCheck,
  ShoppingCart,
  SidebarSimple,
  SignOut,
  SmileySad,
  Sparkle,
  SquaresFour,
  StackPlus,
  Star,
  StarFour,
  TelegramLogo,
  ThumbsUp,
  Timer,
  Trash,
  TrayArrowUp,
  User,
  UserCircle,
  UserList,
  UserSwitch,
  UsersThree,
  Wallet,
  Warning,
  WarningCircle,
  WhatsappLogo,
  X,
  XCircle,
  Eye,
  EyeSlash,
  Lock,
} as const;

export type IconName = keyof typeof IconList;
